"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4494],{

/***/ 20776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_component; }
});

// UNUSED EXPORTS: SUPPORTED_BUTTON_COLORS

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-ladda/dist/index.js
var dist = __webpack_require__(88172);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.js + 1 modules
var button_arrow = __webpack_require__(37759);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./styles/button-colors-mapping.js



var _obj;
/* harmony default export */ var button_colors_mapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, color_consts.BLUE_COLOR_NAME, {
    "background-color": colors/* default.brand-blue */.Z["brand-blue"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.blue-hover */.Z["blue-hover"]
}), (0,_define_property/* default */.Z)(_obj, "outline-blue", {
    "background-color": colors/* default.white */.Z.white,
    color: colors/* default.light-blue */.Z["light-blue"],
    "disabled-background-color": colors/* default.white */.Z.white
}), (0,_define_property/* default */.Z)(_obj, "outline-dark-blue", {
    "background-color": colors/* default.white */.Z.white,
    color: colors/* default.brand-dark-blue */.Z["brand-dark-blue"],
    "hover-color": colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-dark-blue */.Z["brand-dark-blue"]
}), (0,_define_property/* default */.Z)(_obj, "outline-indigo", {
    "background-color": colors/* default.white */.Z.white,
    color: colors/* default.indigo */.Z.indigo,
    "hover-color": colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.indigo */.Z.indigo
}), (0,_define_property/* default */.Z)(_obj, "brand-pink", {
    "background-color": colors/* default.signup-pink */.Z["signup-pink"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.signup-pink-hover */.Z["signup-pink-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-blue", {
    "background-color": colors/* default.brand-blue */.Z["brand-blue"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.blue-hover */.Z["blue-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-red", {
    "background-color": colors/* default.brand-red */.Z["brand-red"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-red-hover */.Z["brand-red-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-green", {
    "background-color": colors/* default.brand-green */.Z["brand-green"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-green-hover */.Z["brand-green-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-yellow", {
    "background-color": colors/* default.brand-yellow */.Z["brand-yellow"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-yellow-hover */.Z["brand-yellow-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-iris", {
    "background-color": colors/* default.brand-iris */.Z["brand-iris"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-iris-hover */.Z["brand-iris-hover"]
}), (0,_define_property/* default */.Z)(_obj, "brand-purple", {
    "background-color": colors/* default.brand-purple */.Z["brand-purple"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-purple-hover */.Z["brand-purple-hover"]
}), //new themes
(0,_define_property/* default */.Z)(_obj, "green", {
    "background-color": colors/* default.green */.Z.green,
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.green-hover */.Z["green-hover"]
}), (0,_define_property/* default */.Z)(_obj, "purple", {
    "background-color": colors/* default.purple */.Z.purple,
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.brand-purple-hover */.Z["brand-purple-hover"]
}), (0,_define_property/* default */.Z)(_obj, color_consts.IRIS_COLOR_NAME, {
    "background-color": colors/* default.iris */.Z.iris,
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.iris-hover */.Z["iris-hover"]
}), (0,_define_property/* default */.Z)(_obj, "yellow", {
    "background-color": colors/* default.yellow */.Z.yellow,
    color: colors/* default.mud */.Z.mud,
    "disabled-background-color": colors/* default.brand-yellow-hover */.Z["brand-yellow-hover"]
}), (0,_define_property/* default */.Z)(_obj, "orange", {
    "background-color": colors/* default.orange */.Z.orange,
    color: colors/* default.mud */.Z.mud,
    "disabled-background-color": colors/* default.orange */.Z.orange
}), (0,_define_property/* default */.Z)(_obj, "pink", {
    "background-color": colors/* default.pink */.Z.pink,
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.pink-hover */.Z["pink-hover"]
}), (0,_define_property/* default */.Z)(_obj, "royal", {
    "background-color": colors/* default.royal */.Z.royal,
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.royal-hover */.Z["royal-hover"]
}), (0,_define_property/* default */.Z)(_obj, color_consts.DODGER_BLUE_COLOR_NAME, {
    "background-color": colors/* default.dodger-blue */.Z["dodger-blue"],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.dodger-blue-hover */.Z["dodger-blue-hover"]
}), (0,_define_property/* default */.Z)(_obj, color_consts.SPACE_BLUE_COLOR_NAME, {
    "background-color": colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default.space-blue-hover */.Z["space-blue-hover"]
}), (0,_define_property/* default */.Z)(_obj, color_consts.WHITE_COLOR_NAME, {
    "background-color": colors/* default.white */.Z.white,
    color: colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR],
    "disabled-background-color": colors/* default.white */.Z.white
}), (0,_define_property/* default */.Z)(_obj, color_consts.BRAND_BLACK_TEXT_COLOR, {
    "background-color": colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR],
    color: colors/* default.white */.Z.white,
    "disabled-background-color": colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR]
}), _obj);

;// CONCATENATED MODULE: ./components/core/button/styles/colors-styles.scss.js



var colorsStyles = "\n  button.ladda-button {\n    &.blue {\n      background-color: ".concat(button_colors_mapping.blue["background-color"], ";\n      color: ").concat(button_colors_mapping.blue.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.blue["background-color"], ";\n        background-color: ").concat(button_colors_mapping.blue.color, ";\n        border-color: ").concat(button_colors_mapping.blue["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.blue["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.blue["disabled-background-color"], ";\n      }\n    }\n\n    &.outline-blue {\n      border-width: 1px;\n      border-style: solid;\n\n      background-color: ").concat(button_colors_mapping["outline-blue"]["background-color"], ";\n      color: ").concat(button_colors_mapping["outline-blue"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["outline-blue"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["outline-blue"].color, ";\n        border-color: ").concat(button_colors_mapping["outline-blue"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["outline-blue"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["outline-blue"]["disabled-background-color"], ";\n      }\n    }\n\n    &.outline-dark-blue,\n    &.outline-dark-blue-inverted-hover {\n      border-width: 1px;\n      border-style: solid;\n\n      background-color: ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n      color: ").concat(button_colors_mapping["outline-dark-blue"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["outline-dark-blue"].color, ";\n        border-color: ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["outline-dark-blue"]["disabled-background-color"], ";\n      }\n    }\n\n    &.outline-dark-blue-inverted-hover:hover {\n      filter: unset;\n      color: ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n      background-color: ").concat(button_colors_mapping["outline-dark-blue"].color, ";\n      border-color: ").concat(button_colors_mapping["outline-dark-blue"]["background-color"], ";\n    }\n\n    &.outline-indigo-inverted-hover {\n      border-width: 1px;\n      border-style: solid;\n\n      background-color: ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n      color: ").concat(button_colors_mapping["outline-indigo"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["outline-indigo"].color, ";\n        border-color: ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n        }\n      }\n      &:hover {\n        filter: unset;\n        color: ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["outline-indigo"].color, ";\n        border-color: ").concat(button_colors_mapping["outline-indigo"]["background-color"], ";\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["outline-indigo"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-pink {\n      background-color: ").concat(button_colors_mapping["brand-pink"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-pink"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-pink"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-pink"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-pink"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-pink"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-pink"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-blue {\n      background-color: ").concat(button_colors_mapping["brand-blue"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-blue"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-blue"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-blue"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-blue"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-blue"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-blue"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-iris {\n      background-color: ").concat(button_colors_mapping["brand-iris"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-iris"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-iris"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-iris"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-iris"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-iris"]["background-color"], ";\n        }\n      }\n    }\n\n    &.brand-red {\n      background-color: ").concat(button_colors_mapping["brand-red"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-red"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-red"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-red"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-red"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-red"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-red"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-green {\n      background-color: ").concat(button_colors_mapping["brand-green"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-green"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-green"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-green"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-green"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-green"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-green"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-yellow {\n      background-color: ").concat(button_colors_mapping["brand-yellow"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-yellow"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-yellow"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-yellow"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-yellow"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-yellow"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-yellow"]["disabled-background-color"], ";\n      }\n    }\n\n    &.brand-purple {\n      background-color: ").concat(button_colors_mapping["brand-purple"]["background-color"], ";\n      color: ").concat(button_colors_mapping["brand-purple"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["brand-purple"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["brand-purple"].color, ";\n        border-color: ").concat(button_colors_mapping["brand-purple"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["brand-purple"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["brand-purple"]["disabled-background-color"], ";\n      }\n    }\n\n    &.green {\n      background-color: ").concat(button_colors_mapping.green["background-color"], ";\n      color: ").concat(button_colors_mapping.green.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.green["background-color"], ";\n        background-color: ").concat(button_colors_mapping.green.color, ";\n        border-color: ").concat(button_colors_mapping.green["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.green["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.green["disabled-background-color"], ";\n      }\n    }\n\n    &.purple {\n      background-color: ").concat(button_colors_mapping.purple["background-color"], ";\n      color: ").concat(button_colors_mapping.purple.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.purple["background-color"], ";\n        background-color: ").concat(button_colors_mapping.purple.color, ";\n        border-color: ").concat(button_colors_mapping.purple["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.purple["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.purple["disabled-background-color"], ";\n      }\n    }\n\n    &.iris {\n      background-color: ").concat(button_colors_mapping.iris["background-color"], ";\n      color: ").concat(button_colors_mapping.iris.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.iris["background-color"], ";\n        background-color: ").concat(button_colors_mapping.iris.color, ";\n        border-color: ").concat(button_colors_mapping.iris["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.iris["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.iris["disabled-background-color"], ";\n      }\n    }\n\n    &.yellow {\n      background-color: ").concat(button_colors_mapping.yellow["background-color"], ";\n      color: ").concat(button_colors_mapping.yellow.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.yellow["background-color"], ";\n        background-color: ").concat(button_colors_mapping.yellow.color, ";\n        border-color: ").concat(button_colors_mapping.yellow["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.yellow["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.yellow["disabled-background-color"], ";\n      }\n    }\n\n    &.orange {\n      background-color: ").concat(button_colors_mapping.orange["background-color"], ";\n      color: ").concat(button_colors_mapping.orange.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.orange["background-color"], ";\n        background-color: ").concat(button_colors_mapping.orange.color, ";\n        border-color: ").concat(button_colors_mapping.orange["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.orange["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.orange["disabled-background-color"], ";\n      }\n    }\n\n    &.pink {\n      background-color: ").concat(button_colors_mapping.pink["background-color"], ";\n      color: ").concat(button_colors_mapping.pink.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.pink["background-color"], ";\n        background-color: ").concat(button_colors_mapping.pink.color, ";\n        border-color: ").concat(button_colors_mapping.pink["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.pink["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.pink["disabled-background-color"], ";\n      }\n    }\n\n    &.royal {\n      background-color: ").concat(button_colors_mapping.royal["background-color"], ";\n      color: ").concat(button_colors_mapping.royal.color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping.royal["background-color"], ";\n        background-color: ").concat(button_colors_mapping.royal.color, ";\n        border-color: ").concat(button_colors_mapping.royal["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping.royal["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping.royal["disabled-background-color"], ";\n      }\n    }\n\n    &.dodger-blue {\n      background-color: ").concat(button_colors_mapping["dodger-blue"]["background-color"], ";\n      color: ").concat(button_colors_mapping["dodger-blue"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["dodger-blue"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["dodger-blue"].color, ";\n        border-color: ").concat(button_colors_mapping["dodger-blue"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["dodger-blue"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["dodger-blue"]["disabled-background-color"], ";\n      }\n    }\n\n    &.crm-dark-tint-01 {\n      background-color: ").concat(colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";\n      }\n    }\n\n    &.wm-contrast-color {\n      background-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME], ";\n      }\n    }\n\n    &.crm-darker-tint-02 {\n      background-color: ").concat(colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";\n      }\n    }\n\n    &.wm-darker-tint-color {\n      background-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME], ";\n        }\n      }\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME], ";\n      }\n    }\n\n    &.dev-darker-int-02 {\n      background-color: ").concat(colors/* default */.Z[color_consts.DEV_DARKER_TINT_02_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DEV_DARKER_TINT_02_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DEV_DARKER_TINT_02_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DEV_DARKER_TINT_02_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DEV_DARKER_TINT_02_COLOR_NAME], ";\n      }\n    }\n\n    &.crm-primary-color {\n      background-color: ").concat(colors/* default */.Z[color_consts.CRM_PRIMARY_COLOR], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.CRM_PRIMARY_COLOR], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.CRM_PRIMARY_COLOR], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.CRM_PRIMARY_COLOR], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.CRM_PRIMARY_COLOR], ";\n      }\n    }\n\n   \n\n    &.dev-primary-color {\n      background-color: ").concat(colors/* default */.Z[color_consts.DEV_PRIMARY_COLOR], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DEV_PRIMARY_COLOR], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DEV_PRIMARY_COLOR], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DEV_PRIMARY_COLOR], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DEV_PRIMARY_COLOR], ";\n      }\n    }\n\n    &.brand-primary-green {\n      background-color: ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME], ";\n      color: ").concat(colors/* default.black */.Z.black, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME], ";\n      }\n    }\n\n    &.brand-green-dark-tint-01 {\n      background-color: ").concat(colors/* default */.Z[color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME], ";\n      }\n    }\n\n    &.workos-iris {\n      background-color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n      }\n    }\n\n    &.marketing-red-dark {\n      background-color: ").concat(colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";\n      }\n    }\n\n    &.crm-green-dark {\n      background-color: ").concat(colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";\n      }\n    }\n\n    &.crm-green {\n      background-color: ").concat(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";\n      color: ").concat(colors/* default.black */.Z.black, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";\n      }\n    }\n   \n\n    &.projects-orange-dark {\n      background-color: ").concat(colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";\n      }\n    }\n\n    &.dev-green-dark {\n      background-color: ").concat(colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";\n      }\n    }\n\n    &.space-blue {\n      background-color: ").concat(button_colors_mapping["space-blue"]["background-color"], ";\n      color: ").concat(button_colors_mapping["space-blue"].color, ";\n\n      &.invert {\n        color: ").concat(button_colors_mapping["space-blue"]["background-color"], ";\n        background-color: ").concat(button_colors_mapping["space-blue"].color, ";\n        border-color: ").concat(button_colors_mapping["space-blue"]["background-color"], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(button_colors_mapping["space-blue"]["background-color"], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(button_colors_mapping["space-blue"]["disabled-background-color"], ";\n      }\n    }\n\n    &.black,\n    &.Black {\n      background-color: ").concat(colors/* default.Black */.Z.Black, ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default.black */.Z.black, ";\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n        border-color: ").concat(colors/* default.black */.Z.black, ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default.black */.Z.black, ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default.Black */.Z.Black, ";\n      }\n    }\n\n    &.white {\n      background-color: ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n      color: ").concat(colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n        background-color: transparent;\n        border-color: ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n      }\n    }\n\n    &.white-iris {\n      background-color: ").concat(colors/* default.white */.Z.white, ";\n      color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n\n      &.invert {\n        color: ").concat(colors/* default.white */.Z.white, ";\n        background-color: ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";\n        border-color: ").concat(colors/* default.white */.Z.white, ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default.white */.Z.white, ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n      }\n    }\n\n    &.gradiant-workos-iris {\n      background: ").concat(colors/* default */.Z[color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME], ";\n        background: ").concat(colors/* default.white */.Z.white, ";\n        border-color: ").concat(colors/* default */.Z[color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default */.Z[color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME], ";\n        }\n      }\n\n      &:disabled {\n        background: ").concat(colors/* default */.Z[color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME], ";\n      }\n    }\n\n    &.white-dodger {\n      background-color: ").concat(colors/* default.white */.Z.white, ";\n      color: ").concat(colors/* default */.Z[color_consts.DODGER_BLUE_COLOR_NAME], ";\n\n      &.invert {\n        color: ").concat(colors/* default.white */.Z.white, ";\n        background-color: ").concat(colors/* default */.Z[color_consts.DODGER_BLUE_COLOR_NAME], ";\n        border-color: ").concat(colors/* default.white */.Z.white, ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default.white */.Z.white, ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n      }\n    }\n    \n    &.service-primary-color {\n      background-color: ").concat(colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";\n      color: ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n\n      &.invert {\n        color: ").concat(colors/* default.white */.Z.white, ";\n        background-color: ").concat(colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";\n        border-color: ").concat(colors/* default.white */.Z.white, ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default.white */.Z.white, ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n      }\n    }\n\n    &.workforms-red {\n      background-color: ").concat(colors/* default */.Z[color_consts.WORKFORMS_RED_COLOR_NAME], ";\n      color: ").concat(colors/* default.white */.Z.white, ";\n\n      &.invert {\n        color: ").concat(colors/* default */.Z[color_consts.WORKFORMS_RED_COLOR_NAME], ";\n        background-color: ").concat(colors/* default.white */.Z.white, ";\n        border-color: ").concat(colors/* default */.Z[color_consts.WORKFORMS_RED_COLOR_NAME], ";\n        &:hover {\n          box-shadow: inset 0 0 0 1px ").concat(colors/* default.black */.Z.black, ";\n        }\n      }\n\n      &:disabled {\n        background-color: ").concat(colors/* default */.Z[color_consts.WORKFORMS_RED_COLOR_NAME], ";\n      }\n    }\n\n    &.with-border {\n      border-width: 1px;\n      border-style: solid;\n    }\n  }\n");

;// CONCATENATED MODULE: ./components/core/button/styles/fonts-styles.scss.js
var fontsStyles = "\n    &.small {\n      font-size: 0.8125rem;\n      padding: 12px 9vw;\n      font-weight: 300;\n    }\n    \n    &.xs {\n      font-size: 0.8125rem;\n      padding: 8px 16px;\n      font-weight: 300;\n    }\n\n    &.sm {\n      font-size: 0.8125rem;\n      padding: 16px 32px;\n      font-weight: 300;\n    }\n\n    &.xl {\n      font-size: 1rem;\n      padding: 16px 120px;\n      font-weight: 400;\n    }\n";

;// CONCATENATED MODULE: ./components/core/button/button-ladda-component.scss.js
/* harmony default export */ var button_ladda_component_scss = ('\n  /*!\n   * Ladda\n   * http://lab.hakim.se/ladda\n   * MIT licensed\n   *\n   * Copyright (C) 2016 Hakim El Hattab, http://hakim.se\n   */\n\n  /*************************************\n   * CONFIG\n   */\n\n  $spinnerSize: 32px;\n\n  /*************************************\n   * BUTTON BASE\n   */\n\n  .ladda-button {\n    position: relative;\n  }\n\n  /* Spinner animation */\n  .ladda-button .ladda-spinner {\n    position: absolute;\n    z-index: 2;\n    display: inline-block;\n    width: $spinnerSize;\n    top: 50%;\n    margin-top: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  /* Button label */\n  .ladda-button .ladda-label {\n    position: relative;\n    z-index: 3;\n  }\n\n  /*************************************\n   * EASING\n   */\n\n  .ladda-button,\n  .ladda-button .ladda-spinner,\n  .ladda-button .ladda-label {\n    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all;\n  }\n\n  .ladda-button[data-style="zoom-in"],\n  .ladda-button[data-style="zoom-in"] .ladda-spinner,\n  .ladda-button[data-style="zoom-in"] .ladda-label,\n  .ladda-button[data-style="zoom-out"],\n  .ladda-button[data-style="zoom-out"] .ladda-spinner,\n  .ladda-button[data-style="zoom-out"] .ladda-label {\n    transition: 0.3s ease all;\n  }\n\n  /*************************************\n   * ZOOM-OUT\n   */\n\n  .ladda-button[data-style="zoom-out"] {\n    overflow: hidden;\n  }\n  .ladda-button[data-style="zoom-out"] .ladda-spinner {\n    left: 50%;\n    margin-left: $spinnerSize;\n\n    transform: scale(2.5);\n  }\n  .ladda-button[data-style="zoom-out"] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n\n  .ladda-button[data-style="zoom-out"][data-loading] .ladda-label {\n    opacity: 0;\n\n    transform: scale(0.5);\n  }\n  .ladda-button[data-style="zoom-out"][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n\n    transform: none;\n  }\n\n  /*************************************\n   * ZOOM-IN\n   */\n\n  .ladda-button[data-style="zoom-in"] {\n    overflow: hidden;\n  }\n  .ladda-button[data-style="zoom-in"] .ladda-spinner {\n    left: 50%;\n    margin-left: $spinnerSize/-2;\n\n    transform: scale(0.2);\n  }\n  .ladda-button[data-style="zoom-in"] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n\n  .ladda-button[data-style="zoom-in"][data-loading] .ladda-label {\n    opacity: 0;\n\n    transform: scale(2.2);\n  }\n  .ladda-button[data-style="zoom-in"][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n\n    transform: none;\n  }\n');

;// CONCATENATED MODULE: ./components/core/button/button-component.scss.js







var StyledButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e62pw7b0"
})(function(param) {
    var buttonColor = param.buttonColor;
    return '\n      button.ladda-button[data-button-color="'.concat(buttonColor, '"] {\n        &:not(.invert) {\n          transition: background-color 200ms ease;\n          &:hover {\n            background-color: ').concat((0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]), ";\n            filter: unset;\n            &.white,\n            &.white-iris {\n              background-color: ").concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";\n            }\n          }\n        }\n      }\n  ");
}, "  &.center{text-align:center;}&.left{align-self:flex-start;}", colorsStyles, " ", button_ladda_component_scss, '  button.ladda-button{padding:16px 32px;font-size:1rem;border-radius:40px;border:none;font-weight:400;text-align:center;cursor:pointer;user-select:none;line-height:17px;&[data-style="zoom-in"]{&:not(:hover){transition:0.1s ease background-color;}}&.disable-animation{&.ladda-button[data-style="zoom-out"] .ladda-label{transition:none !important;z-index:0;}&.ladda-button .ladda-label{transition:none !important;z-index:0;}}&.has-arrow{padding:16px 32px 16px 31px;&.sm{padding-left:29px;}}&.invert{border-width:1px;border-style:solid;}', fontsStyles, "    \n    &.has-paint-animation{isolation:isolate;// https://stackoverflow.com/a/58283449}&:disabled{cursor:auto;}&:hover{outline:none;}img{vertical-align:middle;}.paint-overlay{position:absolute;display:block;width:0;height:0;border-radius:50%;background-color:var(--signup-paint-animation-color);transform:translate(-50%,-50%);z-index:-1;top:8px;left:calc(100% / 2);&.start-animating{animation:paintAnimation 1s ease-in-out;}}@keyframes paintAnimation{0%{width:0;height:0;}60%{width:", "".concat(180 * 2.25, "px"), ";height:", "".concat(180 * 2.25, "px"), ";}100%{opacity:0;}}}");

;// CONCATENATED MODULE: ./components/core/button/button-component.js








var SUPPORTED_BUTTON_COLORS = [
    "blue",
    "outline-blue",
    "outline-dark-blue",
    "outline-dark-blue-inverted-hover",
    "outline-indigo-inverted-hover",
    "brand-blue",
    "brand-red",
    "brand-green",
    "brand-yellow",
    "brand-purple",
    "brand-iris",
    "green",
    "purple",
    "iris",
    "yellow",
    "royal",
    "orange",
    "dodger-blue",
    "white",
    "white-iris",
    "white-dodger",
    color_consts.BRAND_BLACK_TEXT_COLOR,
    color_consts.CRM_DARKER_TINT_02_COLOR_NAME,
    color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    color_consts.DEV_DARKER_TINT_02_COLOR_NAME,
    color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME,
    color_consts.BRAND_BLACK_BACKGROUND_COLOR,
    color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME,
    color_consts.WORKFORMS_RED_COLOR_NAME,
    color_consts.DARK_MARKETING_RED_COLOR_NAME,
    color_consts.DARK_CRM_GREEN_COLOR_NAME,
    color_consts.CRM_GREEN_COLOR_NAME,
    color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME,
    color_consts.DARK_DEV_GREEN_COLOR_NAME,
    color_consts.CRM_DARK_TINT_01_COLOR_NAME,
    color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
    color_consts.BRAND_DARK_COLOR_NAME,
    color_consts.WORK_OS_IRIS_COLOR_NAME,
    color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME,
    color_consts.DEV_PRIMARY_COLOR_NAME,
    color_consts.CRM_PRIMARY_COLOR_NAME,
    color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME
];
var DEFAULT_COLOR = "dodger-blue";
/** @deprecated - use components/core/new-button/button instead */ var ButtonComponent = function(props) {
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(true), startPaintAnimation = ref1[0], setStartPaintAnimation = ref1[1];
    var color = props.color, className = props.className, size = props.size, isLoading = props.isLoading, onClickCallback = props.onClickCallback, children = props.children, type = props.type, disabled = props.disabled, disableAnimation = props.disableAnimation, dataSpinnerColor = props.dataSpinnerColor, invert = props.invert, withBorder = props.withBorder, hasArrow = props.hasArrow, paintButtonColor = props.paintButtonColor, buttonAlign = props.buttonAlign;
    var buttonColor = SUPPORTED_BUTTON_COLORS.indexOf(color) !== -1 ? color : DEFAULT_COLOR;
    (0,react.useEffect)(function() {
        if (paintButtonColor) {
            setStartPaintAnimation(true);
            setTimeout(function() {
                setStartPaintAnimation(false);
            }, 1000);
        }
    }, [
        paintButtonColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonComponent, {
        className: classnames_default()("ladda-button-component ".concat(buttonAlign)),
        buttonColor: buttonColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((dist_default()), {
            className: classnames_default()("".concat(className, " ").concat(buttonColor, " ").concat(size), {
                invert: invert,
                "disable-animation": disableAnimation,
                "with-border": withBorder,
                "has-arrow": hasArrow,
                "has-paint-animation": paintButtonColor
            }),
            "data-style": dist.ZOOM_IN,
            "data-size": dist.XL,
            "data-spinner-color": dataSpinnerColor,
            onClick: onClickCallback,
            type: type,
            loading: isLoading,
            disabled: disabled || isLoading,
            "data-button-color": buttonColor,
            onMouseEnter: function() {
                return setIsHovered(true);
            },
            onMouseLeave: function() {
                return setIsHovered(false);
            },
            children: [
                children,
                hasArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_arrow/* default */.Z, {
                    size: size,
                    hover: isHovered,
                    isSignup: true
                }),
                paintButtonColor && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("paint-overlay", {
                        "start-animating": startPaintAnimation
                    }),
                    style: {
                        "--signup-paint-animation-color": colors/* default */.Z[paintButtonColor]
                    }
                })
            ]
        })
    });
};
ButtonComponent.defaultProps = {
    isLoading: false,
    disableAnimation: false,
    onClickCallback: function() {},
    className: "",
    type: "button",
    withBorder: false
};
/* harmony default export */ var button_component = (ButtonComponent);


/***/ }),

/***/ 89766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmailInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/inputs/email-input-component.scss.js


var StyledEmailInput = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", {
    target: "ebl4qub0"
})("min-width:240px;max-width:320px;display:flex;flex-grow:1;outline:none;&:not(.force-horizontal).mobile-or-tablet{min-width:120px;max-width:none;width:100%;}");

// EXTERNAL MODULE: ./constants/input-validations-patterns.js
var input_validations_patterns = __webpack_require__(18455);
;// CONCATENATED MODULE: ./components/core/inputs/email-input-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var EmailInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmailInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmailInput);
    function EmailInput(props) {
        (0,_class_call_check/* default */.Z)(this, EmailInput);
        var _this;
        _this = _super.call(this, props);
        _this._input = null;
        _this.focus = _this.focus.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(EmailInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var placeholderFocusColor = this.props.placeholderFocusColor;
                if (placeholderFocusColor) {
                    this._input.style.setProperty("--placholder-focus-color", placeholderFocusColor);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var focusOnUpdate = this.props.focusOnUpdate;
                focusOnUpdate && setTimeout(this.focus, 0);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this._input.focus();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                //Dont use input pattern, it doesnt work in safari
                return this._input.checkValidity() && input_validations_patterns/* EMAIL_PATTERN.test */.Q.test(this._input.value);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, focusOnUpdate = _this_props.focusOnUpdate, forceHorizontal = _this_props.forceHorizontal, placeholderFocusColor = _this_props.placeholderFocusColor, otherProps = _object_without_properties(_this_props, [
                    "focusOnUpdate",
                    "forceHorizontal",
                    "placeholderFocusColor"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmailInput, _object_spread_props(_object_spread({}, otherProps), {
                    ref: function(el) {
                        return _this._input = el;
                    }
                }));
            }
        }
    ]);
    return EmailInput;
}(react.PureComponent);

EmailInput.defaultProps = {
    value: "",
    autoComplete: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    className: "email",
    type: "email",
    placeholder: "",
    name: "email",
    required: true,
    focusOnUpdate: false
};


/***/ }),

/***/ 24494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ signup_form_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/signups/regular-signup-component/regular-signup-component.js + 1 modules
var regular_signup_component = __webpack_require__(74115);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/signups/expanding-signup-component/expanding-signup-component.scss.js



var ONLY_BUTTON_WIDTH = "160px";
var FULL_WIDTH = "386px";
var MOBILE_WIDTH = "300px";
var HEIGHT = "48px";
var TRANSITION_TIMING_MILISECONDS = 200;
var WIDTH_TRANSITION = "width ".concat(TRANSITION_TIMING_MILISECONDS, "ms ease");
var PADDING_TRANSITION = "padding ".concat(TRANSITION_TIMING_MILISECONDS, "ms ease");
var StyledExpandingSignupComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1e73g5l0"
})("width:", FULL_WIDTH, ";.signup-form-core-component-wrapper{position:relative;width:", ONLY_BUTTON_WIDTH, ";transition:", WIDTH_TRANSITION, ";form{display:flex;align-items:center;width:100%;}.signup-button-wrapper{position:absolute;width:", ONLY_BUTTON_WIDTH, ";z-index:2;right:0;.signup-button{width:100%;height:", HEIGHT, ";font-size:0.875rem;}}.signup-input{min-width:auto;max-width:none;height:", HEIGHT, ";width:100%;z-index:1;transition:", PADDING_TRANSITION, ";font-size:0.875rem;line-height:8px;padding:12px 24px;border:1px solid;border-radius:40px;outline:none;&:hover::placeholder,&:focus::placeholder{color:var(--placholder-focus-color);}}&.error input,&.error input:focus{border-color:", colors/* default.error */.Z.error, " !important;}&.opened-input{width:", FULL_WIDTH, ";.signup-input{padding-right:", ONLY_BUTTON_WIDTH, ";}}}&.align-center{display:flex;justify-content:center;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){width:", MOBILE_WIDTH, ";.signup-form-core-component-wrapper{text-align:center;width:100%;form{flex-direction:column;}.signup-input{padding:16px 32px;text-align:center;margin:0 0 16px 0;}.signup-button-wrapper{position:relative;width:100%;.signup-button{padding:16px 32px;}}&.opened-input{width:100%;.signup-input{padding:0;}}}}");

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-core/signup-form-core-component.js + 7 modules
var signup_form_core_component = __webpack_require__(35474);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/enhancements/input-error-handler/input-error-handler.js + 1 modules
var input_error_handler = __webpack_require__(84640);
;// CONCATENATED MODULE: ./components/core/signups/expanding-signup-component/expanding-signup-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var SECOND_CTA_KEY = "signup.secondCta";
var ExpandingSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExpandingSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExpandingSignupComponent);
    function ExpandingSignupComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ExpandingSignupComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleShowInput", function() {
            var placement = _this.props.placement;
            var transitionTime = TRANSITION_TIMING_MILISECONDS;
            BigBrain("track", bigbrain_event_types.SIGNUP_FORM_GET_STARTED_CLICKED, {
                placement: placement
            });
            _this.setState({
                emailInputOpened: true,
                useSecondCTA: true
            }, function() {
                return setTimeout(function() {
                    _this._signupComponent.focusOnInput();
                }, transitionTime);
            });
        });
        _this.state = {
            emailInputOpened: props.emailInputOpened,
            useSecondCTA: false
        };
        _this._signupComponent = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(ExpandingSignupComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (window.matchMedia(vp_sizes/* TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY */.fm).matches) {
                    this.setState({
                        emailInputOpened: true
                    });
                }
            }
        },
        {
            key: "getSecondCtaButtonText",
            value: function getSecondCtaButtonText() {
                var translate = this.props.translate;
                return translate(SECOND_CTA_KEY); //removed from default props because of localization
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, buttonColor = _props.buttonColor, alignCenter = _props.alignCenter;
                var _state = this.state, emailInputOpened = _state.emailInputOpened, useSecondCTA = _state.useSecondCTA;
                var onClick = emailInputOpened ? null : this.handleShowInput;
                var ctaText = useSecondCTA ? this.getSecondCtaButtonText() : null;
                var borderColor = colors/* default */.Z[buttonColor];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExpandingSignupComponent, {
                    className: classnames_default()("signup-form-core-outer-wrapper", {
                        "align-center": alignCenter
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_core_component/* default */.Z, _object_spread_props(_object_spread({
                        ref: function(el) {
                            return _this._signupComponent = el;
                        }
                    }, this.props), {
                        emailInputOpened: emailInputOpened,
                        borderColor: borderColor,
                        ctaText: ctaText,
                        useCtaText: !!ctaText,
                        placeholderFocusColor: borderColor
                    }))
                });
            }
        }
    ]);
    return ExpandingSignupComponent;
}(react.PureComponent);
ExpandingSignupComponent.defaultProps = {
    emailInputOpened: true,
    alignCenter: false,
    focusOnLoad: false,
    focusTimeout: 0,
    buttonColor: "brand-pink"
};
/* harmony default export */ var expanding_signup_component = ((0,input_error_handler/* default */.Z)((0,generic_config_context/* withGenericConfig */.P)(ExpandingSignupComponent)));

;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-component.js




function signup_form_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_form_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_form_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function signup_form_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function signup_form_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        signup_form_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var SignupFormComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupFormComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupFormComponent);
    function SignupFormComponent() {
        (0,_class_call_check/* default */.Z)(this, SignupFormComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupFormComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputPlaceholder = _props.inputPlaceholder, useExpandingSignup = _props.useExpandingSignup;
                var SignupComponent = useExpandingSignup ? expanding_signup_component : regular_signup_component/* default */.Z;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupComponent, signup_form_component_object_spread_props(signup_form_component_object_spread({}, this.props), {
                    placeholder: inputPlaceholder
                }));
            }
        }
    ]);
    return SignupFormComponent;
}(react.PureComponent);
SignupFormComponent.defaultProps = {
    forceHorizontal: false
};
/* harmony default export */ var signup_form_component = ((0,generic_config_context/* withGenericConfig */.P)(SignupFormComponent));


/***/ }),

/***/ 35474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ signup_form_core_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/clusters-service.js
var clusters_service = __webpack_require__(90958);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
// EXTERNAL MODULE: ./constants/clusters/sources.js
var sources = __webpack_require__(5792);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/inputs/email-input-component.js + 1 modules
var email_input_component = __webpack_require__(89766);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/button_additional_text_position.js
var button_additional_text_position = __webpack_require__(87154);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
;// CONCATENATED MODULE: ./static/svg/google-icon.svg
var _path, _path2, _path3, _path4;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgGoogleIcon = function SvgGoogleIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 2443,
        height: 2500,
        preserveAspectRatio: "xMidYMid",
        viewBox: "0 0 256 262"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#4285F4",
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#34A853",
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FBBC05",
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#EB4335",
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
    })));
};
/* harmony default export */ var google_icon = (SvgGoogleIcon);

// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
// EXTERNAL MODULE: ./constants/localstorage.js
var localstorage = __webpack_require__(50663);
;// CONCATENATED MODULE: ./client/services/signup/signup-service.js

var updateReferrerBeforeSignup = function() {
    var referrer = document.referrer;
    // don't store referrer if it exists already
    if (localStorage.getItem(localstorage.SIGNUP_REFERRER)) return;
    localStorage.setItem(localstorage.SIGNUP_REFERRER, JSON.stringify({
        value: referrer,
        timestamp: Date.now()
    }));
};

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 1 modules
var emotion_react_browser_esm = __webpack_require__(98012);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/signup-form-core-component.scss.js


var StyledSignupCoreComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1imxfwh0"
})(".additional-button-text{font-style:normal;font-weight:normal;font-size:0.8125rem;line-height:18px;color:", colors/* default.asphalt */.Z.asphalt, ';&.below{margin-top:8px;text-align:center;}&.side{margin-left:16px;text-align:left;}}.signup-button-wrapper{&.additional-text{display:flex;align-items:center;&.additional-text-below{flex-direction:column;}&.additional-text-side{flex-direction:row;}}&.hide-button{visibility:hidden;}&.with-icon{.ladda-button-component{.ladda-label{display:flex;align-items:center;.product-icon{display:flex;margin-right:8px;height:fit-content;}}}}&.with-experimental-animation{button{position:relative;z-index:1;overflow:unset;transform-style:preserve-3D;}button::before{content:"";position:absolute;top:-5%;left:-3%;width:106%;height:110%;z-index:-1;border-radius:100px;//for pill shape\n        transform:translateZ(-1px);background:linear-gradient(\n          to top left,rgba(255,255,255,0) 0%,rgba(255,255,255,0) 45%,rgba(255,255,255,0.5) 48%,rgba(255,255,255,0.8) 50%,rgba(255,255,255,0.5) 52%,rgba(255,255,255,0) 57%,rgba(255,255,255,0) 100%\n        );background-size:600px 600px,100% 100%;background-repeat:no-repeat;background-position:100% 100%,center;animation:shine 4s linear infinite;filter:blur(2px);}@keyframes shine{to{background-position:-100% -100%,center;}}}}&.vertical-google-connect{display:flex;flex-direction:column-reverse;min-width:305px;.social-connect-section{display:flex;flex-direction:column-reverse;justify-content:center;.google-separator{display:flex;align-items:center;margin:16px 0;.seperator-line{flex-grow:1;border-color:', colors/* default.wolf-gray */.Z["wolf-gray"], ";border-top-width:0.5px;border-bottom-width:0.5px;border-style:solid;opacity:0.4;}.separator-text{padding-left:16px;padding-right:16px;font-size:0.8125rem;line-height:24px;color:", colors/* default.asphalt */.Z.asphalt, ";}}.google-connect-button{width:100%;padding-top:12px;padding-bottom:12px;.google-button-inner{display:flex;justify-content:center;.continue-text{display:flex;align-items:center;font-size:0.875rem;}.google-icon{width:24px;height:24px;margin-left:16px;}}}}}.terms-of-service{margin-top:16px;margin-bottom:16px;width:240px;font-size:0.75rem;align-self:center;font-weight:400;line-height:1.125rem;.link{color:inherit;}}&.dark-theme{.additional-button-text{color:", colors/* default.white */.Z.white, ";}.social-connect-section{.google-separator{.separator-text{color:", colors/* default.white */.Z.white, ";}}}.google-connect-button{border:none;}}");

;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/signup-form-core-service.js

var SIGNUP_SOURCE_PARAM = "source";
var WEBSITE_MAIN_SOURCE_VALUE = "web_main";
var NEW_SIGNUP_SOURCE_PARAM = "new_signup_mobile";
//	can test locally with overriding abTests with:
//	[{name:softSignupTests[0].test_name, variant: softSignupTests[0].new_variation_name}]
var addParamsToUrl = function(url) {
    return (0,utils_url.addParamToURL)(url, SIGNUP_SOURCE_PARAM, WEBSITE_MAIN_SOURCE_VALUE);
};

;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/product-icons/work-management-icon.js

var WorkManagementIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "19",
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.57439 12.1966C10.815 12.1966 11.8207 11.1909 11.8207 9.95037C11.8207 8.70979 10.815 7.7041 9.57439 7.7041C8.33381 7.7041 7.32812 8.70979 7.32812 9.95037C7.32812 11.1909 8.33381 12.1966 9.57439 12.1966Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.57439 4.49253C10.815 4.49253 11.8207 3.48685 11.8207 2.24627C11.8207 1.00569 10.815 0 9.57439 0C8.33381 0 7.32812 1.00569 7.32812 2.24627C7.32812 3.48685 8.33381 4.49253 9.57439 4.49253Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.24627 9.81675C3.48685 9.81675 4.49253 8.81106 4.49253 7.57049C4.49253 6.32991 3.48685 5.32422 2.24627 5.32422C1.00569 5.32422 0 6.32991 0 7.57049C0 8.81106 1.00569 9.81675 2.24627 9.81675Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.0451 18.43C6.28567 18.43 7.29136 17.4243 7.29136 16.1838C7.29136 14.9432 6.28567 13.9375 5.0451 13.9375C3.80452 13.9375 2.79883 14.9432 2.79883 16.1838C2.79883 17.4243 3.80452 18.43 5.0451 18.43Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1017 18.431C15.3423 18.431 16.348 17.4253 16.348 16.1847C16.348 14.9442 15.3423 13.9385 14.1017 13.9385C12.8612 13.9385 11.8555 14.9442 11.8555 16.1847C11.8555 17.4253 12.8612 18.431 14.1017 18.431Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.9025 9.81675C18.1431 9.81675 19.1488 8.81106 19.1488 7.57049C19.1488 6.32991 18.1431 5.32422 16.9025 5.32422C15.6619 5.32422 14.6562 6.32991 14.6562 7.57049C14.6562 8.81106 15.6619 9.81675 16.9025 9.81675Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var work_management_icon = (WorkManagementIcon);

;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/product-icons/crm-icon.js

var CRMIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "16",
        viewBox: "0 0 23 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5578 13.8771C11.0537 13.5037 10.5939 13.0675 10.1906 12.576C9.2082 11.379 8.61331 9.91794 8.4751 8.38625L16.1387 8.3861C16.5206 8.38594 16.8301 8.07632 16.8301 7.69444C16.83 6.1314 16.4262 4.58539 15.6456 3.21107C15.0177 2.10568 14.1696 1.15278 13.1632 0.405634C13.902 0.161758 14.6916 0.0297852 15.5121 0.0297852C19.6475 0.0297852 22.9999 3.38216 22.9999 7.51752C22.9999 11.6529 19.6475 15.0053 15.5121 15.0053C14.0605 15.0053 12.7053 14.5922 11.5578 13.8771Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.000488281 7.69457C0.000488281 3.44498 3.44546 0 7.69506 0C9.08159 0 10.3806 0.366118 11.5027 1.00651C11.5155 1.01504 11.5285 1.02318 11.5419 1.03092C12.7213 1.71185 13.7055 2.69767 14.3852 3.89428C14.9314 4.8559 15.26 5.91671 15.358 7.00297H7.69471C7.31272 7.00297 7.00306 7.31263 7.00306 7.69461C7.00306 9.79483 7.73128 11.8301 9.06365 13.4536C9.49381 13.9777 9.97835 14.4485 10.5066 14.8595C9.63621 15.2013 8.68809 15.3891 7.69506 15.3891C3.44546 15.3891 0.000488281 11.9442 0.000488281 7.69457Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var crm_icon = (CRMIcon);

;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/product-icons/dev-icon.js

var DevIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.0592 4.66582C9.32409 4.69936 7.9293 6.11496 7.9293 7.85816C7.9293 9.59951 9.32114 11.014 11.0537 11.0504V11.0538H20.3318V11.0511H20.6975V11.0573C20.8822 11.0639 21.0686 11.1361 21.2219 11.2886L22.77 12.828C23.081 13.1373 23.081 13.6406 22.77 13.9499L21.2219 15.4893C21.0368 15.6734 20.8034 15.7406 20.583 15.7163H11.1222L11.0572 15.716L10.995 15.7163H10.4078C5.70942 15.1564 3.91699 11.3715 3.51992 9.7832L3.50259 9.78753C3.34685 9.17026 3.26411 8.52389 3.26411 7.85816C3.26411 3.61106 6.63131 0.152213 10.8424 0.00491065C10.8928 0.0016537 10.9437 0 10.995 0L11.0601 0.000264158L11.1222 2.38905e-05C11.173 2.38905e-05 11.2233 0.00164219 11.2732 0.00482997C15.4851 0.151298 18.8531 3.61049 18.8531 7.85814C18.8531 8.51215 18.7733 9.14747 18.6228 9.75488H13.5643C13.9563 9.22464 14.1879 8.5686 14.1879 7.85814C14.1879 6.11534 12.7938 4.7 11.0592 4.66582ZM2.57097 11.0511H2.3326C1.04434 11.0511 0 12.0954 0 13.3837C0 14.6719 1.04434 15.7163 2.3326 15.7163H6.42581C4.3053 14.419 3.1291 12.464 2.57097 11.0511Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var dev_icon = (DevIcon);

// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
;// CONCATENATED MODULE: ./components/core/signups/base-signup-form/signup-form-core/signup-form-core-component.js








function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            .error-handling-component .shake .tooltip {\n              bottom: 142px;\n              width: 100%;\n              transform: translate(0, -120%);\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}








































var DEFAULT_CTA_KEY = "signup.cta";
var ENGLISH_CTA_TRANSLATION = "Get Started"; // english translation for event
var SIGNUP = "sign-up";
var _obj;
var PRODUCT_ID_TO_ICON = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, /*#__PURE__*/ (0,jsx_runtime.jsx)(work_management_icon, {})), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, /*#__PURE__*/ (0,jsx_runtime.jsx)(crm_icon, {})), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, /*#__PURE__*/ (0,jsx_runtime.jsx)(dev_icon, {})), _obj);
var CTA_LOCATION = {
    PRICING: "pricing",
    HEADER: "header",
    FIRST_FOLD: "first_fold",
    OTHER: "other"
};
var BRAND_ALLOWED_COLORS = [
    color_consts.WHITE_COLOR_NAME,
    color_consts.BLUE_COLOR_NAME,
    color_consts.WORK_OS_IRIS_COLOR_NAME,
    color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME,
    color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    color_consts.CRM_DARKER_TINT_02_COLOR_NAME,
    color_consts.BRAND_PRIMARY_GREEN_COLOR_NAME,
    color_consts.CRM_GREEN_COLOR_NAME,
    color_consts.DEV_DARKER_TINT_02_COLOR_NAME,
    color_consts.BRAND_BLACK_TEXT_COLOR,
    color_consts.BRAND_BLACK_BACKGROUND_COLOR,
    color_consts.WORKFORMS_RED_COLOR_NAME,
    color_consts.DARK_MARKETING_RED_COLOR_NAME,
    color_consts.DARK_CRM_GREEN_COLOR_NAME,
    color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME,
    color_consts.DARK_DEV_GREEN_COLOR_NAME,
    color_consts.CRM_DARK_TINT_01_COLOR_NAME,
    color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
    color_consts.BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME,
    color_consts.DEV_PRIMARY_COLOR_NAME,
    color_consts.CRM_PRIMARY_COLOR_NAME,
    color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME
];
var loadedAt = new Date().getTime();
var SignupCoreComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupCoreComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupCoreComponent);
    function SignupCoreComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SignupCoreComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getSignupProductId", function() {
            var _props = _this.props, signupProductId = _props.signupProductId, pageProductId = _props.pageProductId, signupClusterId = _props.signupClusterId, pageClusterId = _props.pageClusterId, abTests = _props.abTests;
            var acceptedClustersForProductSignup = [
                clusters.CRM
            ];
            var productId = signupProductId || pageProductId;
            if (productId) {
                return productId;
            }
            var clusterId = signupClusterId || pageClusterId;
            if (clusterId && acceptedClustersForProductSignup.includes(clusterId)) {
                return (0,clusters_service/* getProductByClustersIds */.jw)([
                    clusterId
                ]);
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getSignupClusterId", function() {
            var _props = _this.props, signupClusterId = _props.signupClusterId, pageClusterId = _props.pageClusterId;
            return signupClusterId || pageClusterId;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "setKeepRegionTestCookieIfNeeded", function() {
            var _props = _this.props, abTests = _props.abTests, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, signupWithsolutionAppReferenceId = _props.signupWithsolutionAppReferenceId;
            if (!_this.getSignupProductId() && !isMobileOrTabletBrowser && !signupWithsolutionAppReferenceId) {
                // we exclude mobile viewers from the test at the moment
                // we also exclude the products from it at the moment since we're not sure they're available in AU
                if ((0,acquisition_ab_test_service.shouldGetKeepRegionTest)(abTests, cloudfrontViewerCountry, true)) {
                    // we want to run the test only for regular desktop signups
                    (0,cookies_service/* setCookieIfNeeded */.cr)(cookies.IS_IN_KEEP_REGION_TEST, true);
                }
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "useProductSignup", function() {
            var forceProductSignup = _this.props.forceProductSignup;
            var productIdToUse = _this.getSignupProductId();
            return productIdToUse && (forceProductSignup || (0,products/* shouldGetProductSignup */.Es)(productIdToUse));
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "subscribeToBackNavigation", function(event) {
            if (event === null || event === void 0 ? void 0 : event.persisted) {
                _this.setState({
                    isLoading: false,
                    isGoogleConnectLoading: false
                });
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "focusOnInput", function() {
            _this._emailInput && _this._emailInput.focus();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "handleBeforeSubmitCallback", function() {
            var _props = _this.props, beforeSubmitCallback = _props.beforeSubmitCallback, shouldSendClustersAsParams = _props.shouldSendClustersAsParams;
            if (beforeSubmitCallback) {
                var response = beforeSubmitCallback();
                // Add clusters to form action url
                // We run this here because clusterIds are manipulated after click
                // When the submitUrl is already assigned to the form
                if (response && response.params && shouldSendClustersAsParams) {
                    var keys = Object.keys(response.params);
                    keys.forEach(function(key) {
                        _this._form.action = (0,utils_url.addParamToURL)(_this._form.action, key, response.params[key]);
                    });
                }
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "updateUserCluster", function() {
            var pageSubClusterId = _this.props.pageSubClusterId;
            var clusterToReport = _this.getSignupClusterId() || clusters.GENERIC_CLUSTER;
            (0,clusters_service/* updateUserClustersListWithSingleCluster */.lR)(clusterToReport, types.CLUSTER_TYPE, sources/* HP_SIGNUP_BUTTON */.sL, {
                setSignupCluster: true,
                reason: sources/* SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON */.cv,
                sendBigBrainEvent: true,
                useCaseId: pageSubClusterId
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getCTALocationForGTM", function() {
            var _props = _this.props, segmentNumber = _props.segmentNumber, isPricingPage = _props.isPricingPage;
            if (isPricingPage) {
                return CTA_LOCATION.PRICING;
            }
            if (segmentNumber === 0) {
                return CTA_LOCATION.HEADER;
            }
            if (segmentNumber === 1) {
                return CTA_LOCATION.FIRST_FOLD;
            }
            return CTA_LOCATION.OTHER;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "sendGetStartedEvent", function(kind, scrollPercent) {
            var _props = _this.props, placement = _props.placement, buttonId = _props.buttonId, signupClusterId = _props.signupClusterId, segmentNumber = _props.segmentNumber, segmentType = _props.segmentType, extraData = _props.extraData, useCtaText = _props.useCtaText, ctaText = _props.ctaText;
            var englishText;
            if (!useCtaText) {
                englishText = ENGLISH_CTA_TRANSLATION;
            }
            var signupProductId = _this.getSignupProductId();
            var productKind = signupProductId ? (0,products/* getPlatformProductID */.$4)(signupProductId) : undefined;
            var ctaClickData = {
                placement: placement,
                kind: kind,
                info1: segmentType,
                info2: _this.getButtonText(),
                info3: signupClusterId,
                direct_object_id: scrollPercent,
                direct_object: window.visitGuid,
                board_kind: buttonId,
                value: segmentNumber,
                data: _object_spread({
                    timeStillPageLoad: new Date().getTime() - loadedAt,
                    englishText: englishText,
                    signupProductId: signupProductId,
                    productKind: productKind,
                    wasRedirectedToProductStore: (0,existing_accounts_service/* isExistingAccount */.vn)() && !_this.hasOverridePlatformUrlForExistingAccount()
                }, extraData)
            };
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_MAIN_CTA_CLICKED, ctaClickData);
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SIGNUP_CLICKED, {
                click_text: _this.getButtonText(),
                click_location: _this.getCTALocationForGTM()
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "shouldReplaceGetStartedWithGoToAccount", function() {
            var _props = _this.props, abTests = _props.abTests, useCtaText = _props.useCtaText, signupWithsolutionAppReferenceId = _props.signupWithsolutionAppReferenceId, forceGoToMyAccount = _props.forceGoToMyAccount, persistantCookies = _props.persistantCookies, pricingDetails = _props.pricingDetails;
            if (forceGoToMyAccount) return true;
            if (useCtaText && !pricingDetails || signupWithsolutionAppReferenceId) return false;
            return _this.onlyButton && (0,existing_accounts_service/* isExistingUserInWelcomeBackTest */.LV)(abTests, persistantCookies);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "shouldGetProductSignupFromCampaign", function() {
            var _props = _this.props, abTests = _props.abTests, simulateCampaignProductSignupTest = _props.simulateCampaignProductSignupTest;
            return simulateCampaignProductSignupTest || (0,acquisition_ab_test_service.shouldGetSignupByProductCampaign)(abTests, false);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "isInProductSignupTest", function() {
            var abTests = _this.props.abTests;
            return (0,cookies_service/* getCookie */.ej)(cookies.CAMPAIGN_PRODUCT_COOKIE) && (0,new_ab_tests_service.isInTest)(new_ab_tests.SIGNUP_BY_PRODUCT_CAMPAIGN, abTests);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "handleProductCampaignTest", function() {
            if (_this.isInProductSignupTest()) {
                var abTests = _this.props.abTests;
                (0,cookies_service/* setCookie */.d8)(cookies.EXCLUDE_UTM_PRODUCT_TEST_FROM_ACTIVATION_TEST, true);
                (0,acquisition_ab_test_service.shouldGetSignupByProductCampaign)(abTests, true);
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTextNextToButtonIfNeeded", function() {
            var _props = _this.props, additionalText = _props.additionalText, additionalTextMaxWidth = _props.additionalTextMaxWidth, abTests = _props.abTests, translate = _props.translate;
            if (!additionalText) return;
            var textToUse = additionalText;
            var maxWidthToUse = additionalTextMaxWidth;
            if (textToUse.indexOf("Free forever. No credit card.") > -1 && (0,acquisition_ab_test_service.shouldGetUnlimitedTimeCTATextTest)(abTests, true)) {
                textToUse = translate("signup.button.unlimitedTimeCta");
                maxWidthToUse = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("additional-button-text", _this.additionalTextPosition),
                style: {
                    maxWidth: maxWidthToUse
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    text: textToUse
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "clickGoogleConnectAction", function() {
            var skipUpdateCluster = _this.props.skipUpdateCluster;
            _this.setState({
                isGoogleConnectLoading: true
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_WITH_GOOGLE_CLICKED);
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SIGNUP_WITH_GOOGLE_CLICKED);
            _this.handleBeforeSubmitCallback();
            if (!skipUpdateCluster) {
                _this.updateUserCluster();
            }
            _this.setKeepRegionTestCookieIfNeeded();
            _this.setExcludeFromSignupTestsCookieIfNeeded();
            _this.handleProductCookie();
            window.location.href = (0,mobile/* appendUrlSchemeIfNeeded */.f5)(links/* SIGNUP_WITH_GOOGLE_LINK */.N2g);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "shouldRenderMobileOrTabletGoogleConnect", function() {
            var _props = _this.props, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, showGoogleConnectOnMobile = _props.showGoogleConnectOnMobile, forceVerticalGoogleConnect = _props.forceVerticalGoogleConnect;
            return isMobileOrTabletBrowser && showGoogleConnectOnMobile && (!(0,mobile/* isMeta */.pN)() || (0,mobile/* isMeta */.pN)() && (0,mobile/* isAndroid */.Dt)()) || forceVerticalGoogleConnect;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderGoogleConnect", function() {
            if (_this.shouldRenderMobileOrTabletGoogleConnect()) return _this.renderMobileGoogleConnect();
            return null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "googleConnectButton", function() {
            var _props = _this.props, translate = _props.translate, buttonSize = _props.buttonSize, googleOverrideCtaKey = _props.googleOverrideCtaKey;
            var isGoogleConnectLoading = _this.state.isGoogleConnectLoading;
            var googleConnectColorData = _this.getGoogleConnectColorData();
            var googleConnectKey = googleOverrideCtaKey || "signup.continueWith";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                className: "google-connect-button",
                color: googleConnectColorData.buttonColor,
                size: buttonSize,
                onClickCallback: _this.clickGoogleConnectAction,
                isLoading: isGoogleConnectLoading,
                dataSpinnerColor: colors/* default */.Z[googleConnectColorData.spinnerColorName],
                withBorder: "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "google-button-inner",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "continue-text",
                            children: [
                                " ",
                                translate(googleConnectKey),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(google_icon, {
                            className: "google-icon"
                        })
                    ]
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderMobileGoogleConnect", function() {
            var _props = _this.props, translate = _props.translate, googleSeparatorColor = _props.googleSeparatorColor;
            var colorStyle = {
                color: colors/* default */.Z[googleSeparatorColor],
                borderColor: colors/* default */.Z[googleSeparatorColor]
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("social-connect-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "google-separator",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "seperator-line",
                                style: colorStyle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "separator-text",
                                style: colorStyle,
                                children: [
                                    translate("signup.or"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "seperator-line",
                                style: colorStyle
                            })
                        ]
                    }),
                    _this.googleConnectButton()
                ]
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getGoogleConnectColorData", function() {
            var buttonColor = _this.getButtonColor();
            var _obj;
            var options = (_obj = {}, (0,_define_property/* default */.Z)(_obj, color_consts.WORK_OS_IRIS_COLOR_NAME, {
                spinnerColorName: color_consts.WORK_OS_IRIS_COLOR_NAME,
                buttonColor: "white-iris"
            }), (0,_define_property/* default */.Z)(_obj, color_consts.DODGER_BLUE_COLOR_NAME, {
                spinnerColorName: color_consts.DODGER_BLUE_COLOR_NAME,
                buttonColor: "white-dodger"
            }), (0,_define_property/* default */.Z)(_obj, color_consts.SPACE_BLUE_COLOR_NAME, {
                spinnerColorName: color_consts.SPACE_BLUE_COLOR_NAME,
                buttonColor: "white"
            }), _obj);
            return options[buttonColor] || {
                spinnerColorName: color_consts.SPACE_BLUE_COLOR_NAME,
                buttonColor: "white"
            };
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getButtonColor", function() {
            var buttonColor = _this.props.buttonColor;
            if (!BRAND_ALLOWED_COLORS.includes(buttonColor)) {
                return color_consts.WORK_OS_IRIS_COLOR_NAME;
            }
            return buttonColor;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "signupClicked", function() {
            _this.setKeepRegionTestCookieIfNeeded();
            _this.setExcludeFromSignupTestsCookieIfNeeded();
            _this.onClickSignup();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "gotToAccount", function(platformRedirectUrl, ctaTextKey) {
            var _props = _this.props, buttonId = _props.buttonId, signupClusterId = _props.signupClusterId, segmentNumber = _props.segmentNumber, segmentType = _props.segmentType, translate = _props.translate;
            var buttonTextToUse = translate(ctaTextKey);
            var englishText = "Go to my account"; // CTA's english translation for event
            var ctaClickData = {
                placement: _this.getSignupProductId(),
                kind: platformRedirectUrl,
                info1: segmentType,
                info2: buttonTextToUse,
                info3: signupClusterId,
                board_kind: buttonId,
                value: segmentNumber,
                data: {
                    englishText: englishText
                }
            };
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXISTING_ACCOUNT_MAIN_CTA_CLICKED, ctaClickData);
            window.location = platformRedirectUrl;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTermsOfService", function() {
            var translate = _this.props.translate;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "terms-of-service",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: translate("mobileSignup.termsOfService")
                    }
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getButtonSpinnerColor", function() {
            var buttonSpinnerColor = _this.props.buttonSpinnerColor;
            if (buttonSpinnerColor) return buttonSpinnerColor;
            return _this.getButtonColor() === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "setExcludeFromSignupTestsCookieIfNeeded", function() {
            var excludeFromSignupTests = _this.props.excludeFromSignupTests;
            (0,cookies_service/* setCookieIfNeeded */.cr)(cookies.EXCLUDE_FROM_SIGNUP_TESTS, excludeFromSignupTests);
        });
        _this.state = {
            emailValue: "",
            isLoading: false,
            isGoogleConnectLoading: false
        };
        _this._emailInput = null;
        _this.updateEmail = _this.updateEmail.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleSubmit = _this.handleSubmit.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleUserSignup = _this.handleUserSignup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.submitFormIfNeeded = _this.submitFormIfNeeded.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClickSignup = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this), SIGNUP);
        _this.onlyButton = _this.shouldSeeOnlyButton(props);
        var isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, additionalTextPosition = props.additionalTextPosition;
        _this.additionalTextPosition = isMobileOrTabletBrowser ? button_additional_text_position/* BELOW */._ : additionalTextPosition;
        return _this;
    }
    (0,_create_class/* default */.Z)(SignupCoreComponent, [
        {
            key: "shouldSeeOnlyButton",
            value: function shouldSeeOnlyButton(props) {
                var forceInputHide = props.forceInputHide, forceDefaultForm = props.forceDefaultForm, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser;
                if (forceInputHide) return true;
                if (forceDefaultForm) return false;
                if (isMobileOrTabletBrowser) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "getProductSignupURLWithProductId",
            value: function getProductSignupURLWithProductId() {
                return (0,products/* getProductSignupURL */.DQ)(this.getSignupProductId());
            }
        },
        {
            key: "handleProductCookie",
            value: function handleProductCookie() {
                var excludeFromWMHighIntentExperienceTest = this.props.excludeFromWMHighIntentExperienceTest;
                var productForSignup = this.getSignupProductId();
                if (this.useProductSignup() && productForSignup === products/* WORK_MANAGEMENT_PRODUCT_ID */.py && !excludeFromWMHighIntentExperienceTest) {
                    (0,cookies_service/* setCookie */.d8)(cookies.WM_HIGH_INTENT_EXPERIENCE_COOKIE_NAME, true, {
                        expires: 1
                    }); // Mark product cookie to sync with platform - live for 1 day
                } else {
                    // In case user clicked on wm high intent Get Started, clicked back and then clicked on another 'Get Started'
                    // button that is not WM high intent
                    (0,cookies_service/* removeCookie */.nJ)(cookies.WM_HIGH_INTENT_EXPERIENCE_COOKIE_NAME);
                }
                if (!this.onlyButton) {
                    if (this.useProductSignup() && productForSignup !== products/* WORK_MANAGEMENT_PRODUCT_ID */.py) {
                        var platformProduct = products/* PLATFORM_PRODUCT_IDS */.xZ[productForSignup];
                        if (platformProduct) {
                            (0,cookies_service/* setCookie */.d8)(cookies.WEBSITE_PRODUCT_SIGNUP_COOKIE_NAME, platformProduct, {
                                expires: 1
                            });
                        }
                    } else {
                        (0,cookies_service/* removeCookie */.nJ)(cookies.WEBSITE_PRODUCT_SIGNUP_COOKIE_NAME);
                    }
                }
            }
        },
        {
            key: "hasOverridePlatformUrlForExistingAccount",
            value: function hasOverridePlatformUrlForExistingAccount() {
                var _props = this.props, persistantCookies = _props.persistantCookies, platformUrlOverrideForExistingAccount = _props.existingAccount.platformUrlOverrideForExistingAccount;
                return platformUrlOverrideForExistingAccount && (0,existing_accounts_service/* isExistingUserInHeader */.xy)(persistantCookies);
            }
        },
        {
            key: "getPlatformOverrideUrlForExistingAccount",
            value: function getPlatformOverrideUrlForExistingAccount() {
                var _props = this.props, platformUrlOverrideForExistingAccount = _props.existingAccount.platformUrlOverrideForExistingAccount;
                return (0,existing_accounts_service/* getMondayUrl */.Xm)(platformUrlOverrideForExistingAccount);
            }
        },
        {
            key: "getSubmitUrl",
            value: function getSubmitUrl(campaignProductCookie) {
                var _props = this.props, submitUrl = _props.submitUrl, signupWithsolutionAppReferenceId = _props.signupWithsolutionAppReferenceId;
                var overrideUrl;
                if (!this.onlyButton) {
                    // mobile / popup - with email
                    overrideUrl = (0,utils_url.addParamToURL)(addParamsToUrl(links/* VERIFY_EMAIL_LINK */.$mb), NEW_SIGNUP_SOURCE_PARAM, "1");
                    (0,cookies_service/* setCookie */.d8)(cookies.SOFT_SIGNUP_MOBILE_TEST_COOKIE_NAME, true);
                } else if ((0,existing_accounts_service/* isExistingAccount */.vn)() && this.hasOverridePlatformUrlForExistingAccount()) {
                    overrideUrl = this.getPlatformOverrideUrlForExistingAccount();
                } else if ((0,existing_accounts_service/* isExistingAccount */.vn)() && (0,products/* getProductTemplateId */.nl)(this.getSignupProductId())) {
                    overrideUrl = (0,existing_accounts_service/* getMondayUrl */.Xm)("/product_store/".concat((0,products/* getProductTemplateId */.nl)(this.getSignupProductId())));
                } else if (this.useProductSignup()) {
                    overrideUrl = this.getProductSignupURLWithProductId();
                } else if (signupWithsolutionAppReferenceId) {
                    // sign up with specific solution
                    overrideUrl = (0,links/* getPlatformAddSolutionLink */.pHh)(signupWithsolutionAppReferenceId);
                } else if (campaignProductCookie && this.shouldGetProductSignupFromCampaign()) {
                    overrideUrl = (0,products/* getProductSignupURL */.DQ)(campaignProductCookie);
                }
                return overrideUrl || submitUrl;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, focusOnLoad = _props.focusOnLoad, isFirstSegment = _props.isFirstSegment, isPreview = _props.isPreview, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
                if (isPreview) return;
                var shouldFocus = (focusOnLoad || isFirstSegment) && !isMobileOrTabletBrowser;
                shouldFocus && this.focusOnInput();
                window.addEventListener("pageshow", this.subscribeToBackNavigation);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("pageshow", this.subscribeToBackNavigation);
            }
        },
        {
            key: "submitFormIfNeeded",
            value: function submitFormIfNeeded(event) {
                if (event.key === "Enter") {
                    this.handleSubmit();
                    event.preventDefault();
                }
            }
        },
        {
            key: "updateEmail",
            value: function updateEmail(event) {
                var emailValue = this.state.emailValue;
                var _props = this.props, errorStateCallback = _props.errorStateCallback, parentSegment = _props.parentSegment, segmentNumber = _props.segmentNumber;
                if (!emailValue) (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_START_FILL_EMAIL, {
                    info1: parentSegment,
                    info2: this.getButtonText(),
                    info3: segmentNumber
                });
                this.setState({
                    emailValue: event.target.value
                });
                errorStateCallback(false);
            }
        },
        {
            key: "handleSubmit",
            value: function handleSubmit() {
                var kind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SIGNUP;
                var _this = this;
                return _async_to_generator(function() {
                    var _props, errorStateCallback, placement, parentSegment, buttonSource, segmentNumber, loadingButtonKey, emailValue;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this.props, errorStateCallback = _props.errorStateCallback, placement = _props.placement, parentSegment = _props.parentSegment, buttonSource = _props.buttonSource, segmentNumber = _props.segmentNumber;
                                loadingButtonKey = "isLoading";
                                _this.setState((0,_define_property/* default */.Z)({}, loadingButtonKey, true));
                                if (!_this.onlyButton && !_this._emailInput.isValid()) {
                                    emailValue = _this.state.emailValue;
                                    _this.setState({
                                        isLoading: false
                                    });
                                    _this._emailInput.focus();
                                    errorStateCallback(true);
                                    (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_SUBMIT_CLICK_WITH_EMAIL_ERROR, {
                                        info1: emailValue,
                                        info2: parentSegment,
                                        info3: segmentNumber
                                    }); // Not PII since email isn't valid.
                                    return [
                                        2
                                    ];
                                }
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_FORM_SUBMIT, {
                                    placement: placement,
                                    kind: kind,
                                    info1: parentSegment,
                                    info3: buttonSource
                                });
                                _this.handleBeforeSubmitCallback();
                                return [
                                    4,
                                    _this.handleUserSignup(kind)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleUserSignup",
            value: function handleUserSignup(kind) {
                var _this = this;
                return _async_to_generator(function() {
                    var skipUpdateCluster, scrollPercent;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                skipUpdateCluster = _this.props.skipUpdateCluster;
                                if (!skipUpdateCluster) {
                                    _this.updateUserCluster();
                                }
                                return [
                                    4,
                                    (0,dom_utils_service.getScrollPercent)()
                                ];
                            case 1:
                                scrollPercent = _state.sent();
                                _this.handleProductCookie();
                                _this.sendGetStartedEvent(kind, scrollPercent);
                                _this.handleProductCampaignTest();
                                updateReferrerBeforeSignup();
                                _this._form.submit();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getButtonText",
            value: function getButtonText() {
                var _props = this.props, useCtaText = _props.useCtaText, ctaText = _props.ctaText, translate = _props.translate;
                var _props1 = this.props, persistantCookies = _props1.persistantCookies, existingAccountCtaText = _props1.existingAccount.existingAccountCtaText;
                var buttonText;
                // If existing account
                if (existingAccountCtaText && (0,existing_accounts_service/* isExistingUserInHeader */.xy)(persistantCookies)) {
                    buttonText = existingAccountCtaText;
                } else if (useCtaText && ctaText) {
                    buttonText = ctaText;
                }
                if (!buttonText) {
                    buttonText = translate(DEFAULT_CTA_KEY);
                }
                return buttonText;
            }
        },
        {
            key: "getPlaceholderText",
            value: function getPlaceholderText() {
                var _props = this.props, placeholder = _props.placeholder, translate = _props.translate;
                return placeholder || translate("signup.emailInputPlaceholder");
            }
        },
        {
            key: "onClick",
            value: function onClick(kind) {
                var _state = this.state, emailValue = _state.emailValue, isLoading = _state.isLoading;
                if (isLoading) return; //	disable in button cause css issues, need to think about it
                if (!this.onlyButton && !emailValue) {
                    (0,bigbrain_service.trackEvent)(bigbrain_event_types.CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL);
                }
                this.handleSubmit(kind);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, buttonSize = _props.buttonSize, origin = _props.origin, isErrorState = _props.isErrorState, className = _props.className, forceHorizontal = _props.forceHorizontal, emailInputOpened = _props.emailInputOpened, borderColor = _props.borderColor, disableButtonAnimation = _props.disableButtonAnimation, placeholderFocusColor = _props.placeholderFocusColor, withButtonArrow = _props.withButtonArrow, freeTierForcePrevent = _props.freeTierForcePrevent, additionalText = _props.additionalText, isMobileInputTransparent = _props.isMobileInputTransparent, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, showGoogleConnectOnMobile = _props.showGoogleConnectOnMobile, invert = _props.invert, displayedOnDarkTheme = _props.displayedOnDarkTheme, forceVerticalGoogleConnect = _props.forceVerticalGoogleConnect, translate = _props.translate, pricingDetails = _props.pricingDetails, pageSubClusterId = _props.pageSubClusterId, paintButtonColor = _props.paintButtonColor, existingAccount = _props.existingAccount, productIdToUse = _props.productIdToUse, useCtaIcon = _props.useCtaIcon, buttonAlign = _props.buttonAlign, useExperimentalAnimation = _props.useExperimentalAnimation, forceInputHide = _props.forceInputHide;
                var isLoading = this.state.isLoading;
                var campaignProductCookie = (0,cookies_service/* getCookie */.ej)(cookies.CAMPAIGN_PRODUCT_COOKIE);
                var hideSignupButton = false;
                var buttonTextToUse = this.getButtonText();
                var placeholderToUse = this.getPlaceholderText();
                var submitUrl = this.getSubmitUrl(campaignProductCookie);
                var fullUrl = (0,utils_url.addParamToURL)(submitUrl, "origin", origin);
                fullUrl = freeTierForcePrevent ? (0,utils_url.addParamToURL)(fullUrl, query_params.PREVENT_FREE_TIER_PARAM, freeTierForcePrevent) : fullUrl;
                var buttonUpdatedColor = this.getButtonColor();
                var clickAction = this.signupClicked;
                // existing account flow:
                if (this.shouldReplaceGetStartedWithGoToAccount()) {
                    var ctaProps = (0,existing_accounts_service/* getWelcomeBackCTAProps */.Sb)({
                        productId: this.getSignupProductId(),
                        clusterId: this.getSignupClusterId(),
                        subClusterId: pageSubClusterId,
                        pricingDetails: pricingDetails,
                        existingAccount: existingAccount
                    });
                    // this flow disconnects the form and it's submission completely
                    buttonTextToUse = translate(ctaProps.ctaTextKey);
                    clickAction = function() {
                        return _this.gotToAccount(ctaProps.platformRedirectUrl, ctaProps.ctaTextKey);
                    };
                    hideSignupButton = ctaProps.hideButton;
                }
                // Google connect
                var renderGoogleConnect = isMobileOrTabletBrowser && showGoogleConnectOnMobile || forceVerticalGoogleConnect;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupCoreComponent, {
                    className: classnames_default()("signup-form-core-component-wrapper", className, {
                        error: isErrorState,
                        "force-horizontal": forceHorizontal,
                        "opened-input": emailInputOpened,
                        "vertical-google-connect": renderGoogleConnect,
                        "dark-theme": displayedOnDarkTheme,
                        "mobile-or-tablet": isMobileOrTabletBrowser
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "signup-form",
                            action: fullUrl,
                            "data-origin": origin,
                            method: "POST",
                            noValidate: true,
                            ref: function(el) {
                                return _this._form = el;
                            },
                            children: [
                                !this.onlyButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(email_input_component/* default */.Z, {
                                    className: classnames_default()("signup-input", {
                                        "force-horizontal": forceHorizontal,
                                        transparent: isMobileInputTransparent,
                                        "mobile-or-tablet": isMobileOrTabletBrowser
                                    }),
                                    ref: function(el) {
                                        return _this._emailInput = el;
                                    },
                                    value: this.state.emailValue,
                                    onChange: this.updateEmail,
                                    placeholder: placeholderToUse,
                                    onKeyPress: this.submitFormIfNeeded,
                                    autoComplete: "on",
                                    placeholderFocusColor: placeholderFocusColor,
                                    style: {
                                        borderColor: borderColor
                                    },
                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("signup-button-wrapper", additionalText && "additional-text additional-text-".concat(this.additionalTextPosition), {
                                        "button-with-arrow": withButtonArrow,
                                        "hide-button": hideSignupButton,
                                        "with-icon": useCtaIcon,
                                        "with-experimental-animation": useExperimentalAnimation
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_component/* default */.Z, {
                                            className: "signup-button",
                                            color: buttonUpdatedColor,
                                            size: buttonSize,
                                            isLoading: isLoading,
                                            onClickCallback: clickAction,
                                            disableAnimation: disableButtonAnimation,
                                            dataSpinnerColor: this.getButtonSpinnerColor(),
                                            invert: invert,
                                            hasArrow: withButtonArrow,
                                            paintButtonColor: paintButtonColor,
                                            buttonAlign: buttonAlign,
                                            children: [
                                                useCtaIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-icon",
                                                    children: PRODUCT_ID_TO_ICON[productIdToUse]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "signup-text",
                                                    children: buttonTextToUse
                                                })
                                            ]
                                        }),
                                        this.renderTextNextToButtonIfNeeded()
                                    ]
                                }),
                                !this.onlyButton && this.renderTermsOfService()
                            ]
                        }),
                        renderGoogleConnect && this.renderGoogleConnect(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_react_browser_esm/* Global */.xB, {
                            styles: (0,emotion_react_browser_esm/* css */.iv)(_templateObject())
                        })
                    ]
                });
            }
        }
    ]);
    return SignupCoreComponent;
}(react.PureComponent);
SignupCoreComponent.defaultProps = {
    focusOnLoad: false,
    disableButtonAnimation: false,
    borderColor: "grey",
    submitUrl: links/* NEW_SOFT_SIGNUP_LINK */.SXZ,
    origin: "hp_fullbg_page_header",
    forceDefaultForm: false,
    forceInputHide: false,
    withButtonArrow: false,
    useCtaText: false,
    ctaText: null,
    additionalText: false,
    additionalTextPosition: button_additional_text_position/* BELOW */._,
    additionalTextMaxWidth: null,
    buttonId: null,
    segmentNumber: null,
    isMobileInputTransparent: false,
    skipUpdateCluster: false,
    showGoogleConnectOnMobile: false,
    invert: null,
    displayedOnDarkTheme: false,
    forceVerticalGoogleConnect: false,
    forceProductSignup: false,
    forceGoToMyAccount: false,
    existingAccount: {
        platformUrlOverrideForExistingAccount: ""
    },
    extraData: {}
};
/* harmony default export */ var signup_form_core_component = ((0,segment_context/* withSegmentsData */.c)((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SignupCoreComponent))));


/***/ }),

/***/ 74115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_signup_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/signups/regular-signup-component/regular-signup-component.scss.js




var StyledRegularSignupComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euarw00"
})("width:100%;.signup-form-core-component-wrapper{form{flex-wrap:wrap;display:inline-flex;align-items:center;width:100%;justify-content:center;}.phoneno{display:none;}&.align-left{form{justify-content:flex-start;}}&.hide-form{visibility:hidden;}&:not(.force-horizontal).mobile-or-tablet{form{flex-direction:column;}}}.signup-form-core-component-wrapper{display:flex;justify-content:center;width:100%;input{font-size:0.875rem;line-height:8px;padding:12px 24px;border-radius:32px;-webkit-appearance:none;//Remove shadow from input in mobile safari\n\n      background-color:", colors/* default.light-grey */.Z["light-grey"], ";color:", colors/* default.black */.Z.black, ";border:1px solid;border-color:", colors/* default.grey */.Z.grey, ";text-align:center;transition:border-color 0.1s ease-in-out;margin:8px 16px 8px 0;&:hover::placeholder,&:focus::placeholder{color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}&:focus{border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default.white */.Z.white, ";}&.transparent{background-color:rgba(255,255,255,0.1);color:", colors/* default.white */.Z.white, ";&::placeholder{color:", colors/* default.white */.Z.white, ";opacity:0.8;}}}&.error input,&.error input:focus{border-color:", colors/* default.error */.Z.error, ";}button.ladda-button.sm{font-size:0.875rem;}.only-button{min-width:300px;}.signup-button-wrapper{.signup-button{min-width:130px;&.secondary-button{@media (max-width:1058px){margin-top:8px;}@media (min-width:1058px){margin-left:24px;}}}&.button-with-arrow{.signup-button{padding-right:20px;&.xs{padding-right:14px;}&.xxs{padding-right:8px;padding-left:8px;font-size:0.6875rem;padding-top:8px;padding-bottom:8px;}}}}}.signup-form-core-component-wrapper.mobile-or-tablet{&:not(.force-horizontal){text-align:center;input{margin-bottom:16px;font-size:1rem;padding:11.5px 8px;margin-right:0;min-width:264px;}.signup-button-wrapper{width:100%;.ladda-button-component{width:100%;button{font-size:0.875rem;width:100%;}}}&.button-with-arrow{button.signup-button{padding-right:32px;}}}}");

// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-core/signup-form-core-component.js + 7 modules
var signup_form_core_component = __webpack_require__(35474);
// EXTERNAL MODULE: ./components/enhancements/input-error-handler/input-error-handler.js + 1 modules
var input_error_handler = __webpack_require__(84640);
;// CONCATENATED MODULE: ./components/core/signups/regular-signup-component/regular-signup-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var RegularSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularSignupComponent);
    function RegularSignupComponent(props) {
        (0,_class_call_check/* default */.Z)(this, RegularSignupComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(RegularSignupComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRegularSignupComponent, {
                    className: "regular-signup-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_core_component/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                        disableButtonAnimation: true
                    }))
                });
            }
        }
    ]);
    return RegularSignupComponent;
}(react.PureComponent);
/* harmony default export */ var regular_signup_component = ((0,input_error_handler/* default */.Z)(RegularSignupComponent));


/***/ }),

/***/ 84640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ withErrorHandler; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/enhancements/shake/shake-component.js + 1 modules
var shake_component = __webpack_require__(89868);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/enhancements/input-error-handler/input-error-handler.scss.js


var StyledWithErrorComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef4360k0"
})("position:relative;width:100%;.error-tooltip-text{color:red;font-weight:300;}.tooltip{transform:translate(0,-120%);}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.tooltip{transform:translate(5%,-120%);}}");

;// CONCATENATED MODULE: ./components/enhancements/input-error-handler/input-error-handler.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








function withErrorHandler(WrappedComponent) {
    var WithErrorComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_inherits/* default */.Z)(WithErrorComponent, PureComponent);
        var _super = (0,_create_super/* default */.Z)(WithErrorComponent);
        function WithErrorComponent(props) {
            (0,_class_call_check/* default */.Z)(this, WithErrorComponent);
            var _this;
            _this = _super.call(this, props);
            _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleClickOutside", function() {
                _this.setState({
                    error: false,
                    shouldShake: false
                });
            });
            _define_property((0,_assert_this_initialized/* default */.Z)(_this), "resetShaker", function() {
                if (_this.state.shouldShake) {
                    setTimeout(function() {
                        return _this.setState({
                            shouldShake: false
                        });
                    }, 600);
                }
            });
            _define_property((0,_assert_this_initialized/* default */.Z)(_this), "updateErrorState", function(error) {
                _this.setState({
                    error: error,
                    shouldShake: error
                }, _this.resetShaker);
            });
            _this.state = {
                error: false,
                shouldShake: false
            };
            return _this;
        }
        (0,_create_class/* default */.Z)(WithErrorComponent, [
            {
                key: "renderErrorMessageIfNeeded",
                value: function renderErrorMessageIfNeeded() {
                    var _props = this.props, preventErrorMessage = _props.preventErrorMessage, translate = _props.translate;
                    var error = this.state.error;
                    var errorText = translate("signup.emailError");
                    if (!error || preventErrorMessage) return;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "error-tooltip-text",
                            children: errorText
                        })
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _state = this.state, error = _state.error, shouldShake = _state.shouldShake;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWithErrorComponent, {
                        className: classnames_default()("error-handling-component"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shake_component/* default */.Z, {
                            isActive: shouldShake,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, _object_spread_props(_object_spread({}, this.props), {
                                    isErrorState: error,
                                    errorStateCallback: this.updateErrorState
                                })),
                                this.renderErrorMessageIfNeeded()
                            ]
                        })
                    });
                }
            }
        ]);
        return WithErrorComponent;
    }(react.PureComponent);
    return (0,generic_config_context/* withGenericConfig */.P)((0,react_onclickoutside_es/* default */.Z)(WithErrorComponent));
}


/***/ }),

/***/ 89868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShakeComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/enhancements/shake/shake-component.scss.js

var StyledShakeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ul26g0"
})("@keyframes shake{10%,90%{transform:translate3d(-1px,0,0);}20%,80%{transform:translate3d(2px,0,0);}30%,50%,70%{transform:translate3d(-4px,0,0);}40%,60%{transform:translate3d(4px,0,0);}}display:flex;&.active{animation:shake 0.5s cubic-bezier(0.36,0.07,0.19,0.97) both;transform:translate3d(0,0,0);animation-iteration-count:1;}");

;// CONCATENATED MODULE: ./components/enhancements/shake/shake-component.js







var ShakeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShakeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShakeComponent);
    function ShakeComponent() {
        (0,_class_call_check/* default */.Z)(this, ShakeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ShakeComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, isActive = _props.isActive;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShakeComponent, {
                    className: "shake ".concat(isActive ? "active" : "stop"),
                    children: children
                });
            }
        }
    ]);
    return ShakeComponent;
}(react.PureComponent);

ShakeComponent.defaultProps = {
    isActive: false
};


/***/ }),

/***/ 31590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TooltipComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/tooltip/tooltip-component.scss.js



var darkColor = colors/* default.mud */.Z.mud;
var lightColor = colors/* default.white */.Z.white;
var SIZE = "12px";
var StyledTooltipComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1owr6x20"
})("font-size:0.8125rem;border-radius:8px;padding:14px;z-index:", z_index/* MODAL_BACKGROUND */.AE - 1, ";white-space:nowrap;box-shadow:0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);position:absolute;&.light{background-color:", lightColor, ";color:", darkColor, ";&:after{border-top-color:", lightColor, ";}}&.dark{background-color:", darkColor, ";color:", lightColor, ";&:after{border-top-color:", darkColor, ';}}&:after{content:"";position:absolute;left:calc(50% - ', SIZE, " / 3);width:0;height:0;bottom:calc(1px - ", SIZE, ");border-style:solid;border-width:", SIZE, " ", SIZE, " 0 ", SIZE, ";border-color:transparent;}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
;// CONCATENATED MODULE: ./components/enhancements/tooltip/tooltip-component.js









var TooltipComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TooltipComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TooltipComponent);
    function TooltipComponent() {
        (0,_class_call_check/* default */.Z)(this, TooltipComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TooltipComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooltipComponent, {
                    className: classnames_default()("tooltip", theme, className),
                    children: this.props.children
                });
            }
        }
    ]);
    return TooltipComponent;
}(react.PureComponent);

TooltipComponent.defaultProps = {
    theme: tooltip_constants.LIGHT_THEME
};


/***/ }),

/***/ 24984:
/***/ (function(module) {


module.exports = {
    LIGHT_THEME: "light",
    DARK_THEME: "dark"
};


/***/ }),

/***/ 18455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ EMAIL_PATTERN; }
/* harmony export */ });
/* unused harmony export PHONE_NUMBER_PATTERN */
var EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*){2,}|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var PHONE_NUMBER_PATTERN = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/im;


/***/ }),

/***/ 14124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getMondaySlugsDetails; },
/* harmony export */   "Cm": function() { return /* binding */ getMondayFullUrlForSlug; },
/* harmony export */   "LM": function() { return /* binding */ isExistingNonPayingAccount; },
/* harmony export */   "LV": function() { return /* binding */ isExistingUserInWelcomeBackTest; },
/* harmony export */   "Sb": function() { return /* binding */ getWelcomeBackCTAProps; },
/* harmony export */   "Xm": function() { return /* binding */ getMondayUrl; },
/* harmony export */   "YF": function() { return /* binding */ getLastUsedAccountSlug; },
/* harmony export */   "pF": function() { return /* binding */ DEFAULT_PLATFORM_USER_IMAGE_SOURCE; },
/* harmony export */   "r": function() { return /* binding */ setWelcomeBackCookie; },
/* harmony export */   "tV": function() { return /* binding */ SLUG_DETAILS_COOKIE_NAME; },
/* harmony export */   "vn": function() { return /* binding */ isExistingAccount; },
/* harmony export */   "xy": function() { return /* binding */ isExistingUserInHeader; }
/* harmony export */ });
/* unused harmony exports ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME, getMondayActiveSlugs, validateAllAccountsCreatedAfterDate, fireAbTestVariantInAccountTestIfNeeded, getSignupLink */
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67798);
/* harmony import */ var constants_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13019);
/* harmony import */ var constants_cookies__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_cookies__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_new_ab_tests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60734);
/* harmony import */ var constants_new_ab_tests__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constants_new_ab_tests__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64487);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var services_dom_utils_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44566);
/* harmony import */ var services_dom_utils_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(services_dom_utils_service__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84074);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65488);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27639);
/* eslint-disable camelcase */ 
function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME = "monday_active_account_slugs"; // set in the platform after each login expiry 1 year
var ALL_SLUGS_COOKIE_NAME = "dapulseAccountSlugs"; // set in the platform after each login - session cookie no expiration
var SLUG_DETAILS_COOKIE_NAME = "monday_slug_details"; // set in the platform after each login - saves up to 3 last slugs
var WELCOME_BACK_COOKIE_EXPIRATION_DAYS = 30;
var DEFAULT_PLATFORM_USER_IMAGE_SOURCE = "https://cdn1.monday.com/dapulse_default_photo.png";
// Payment form params
var PAYMENT_TIER_PARAM = "tier";
var PAYMENT_PERIOD_PARAM = "period";
var PAYMENT_USERS_COUNT_PARAM = "users_count";
var PAYMENT_SOURCE_PARAM = "source";
// Returns array of slug names (string)
var getMondayActiveSlugs = function() {
    var slugsFromCookie = getCookie(ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME);
    var slugs = [];
    if (slugsFromCookie) {
        try {
            slugsFromCookie = decodeURIComponent(slugsFromCookie);
            slugs = JSON.parse(slugsFromCookie);
        } catch (err) {
            Sentry.captureException(err);
        }
    }
    return slugs;
};
var getMondaySlugsDetails = function() {
    var slugsFromCookie = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SLUG_DETAILS_COOKIE_NAME);
    var parsedSlugsDetails = [];
    if (slugsFromCookie) {
        try {
            slugsFromCookie = decodeURIComponent(slugsFromCookie);
            var slugsDetails = JSON.parse(slugsFromCookie);
            var fixedSlugDetails = slugsDetails.filter(function(slugDetail) {
                return slugDetail.account_name || slugDetail.an;
            }); // fixes a bug where empty slug details were saved
            parsedSlugsDetails = fixedSlugDetails.map(function(slugDetail) {
                return parseSingleAccountSlugDetails(slugDetail);
            });
        } catch (err) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureException */ .Tb(err);
        }
    }
    return parsedSlugsDetails;
};
var isExistingAccount = function() {
    return getLastUsedAccountSlug() !== undefined;
};
var getLastUsedAccountSlug = function() {
    return (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(constants_cookies__WEBPACK_IMPORTED_MODULE_1__.LAST_ACCOUNT_SLUG);
};
var getMondayFullUrlForSlug = function(slug) {
    return "//".concat(slug, ".").concat("monday.com"); // works also in client side (next trick)
};
var getMondayUrl = function(relativeUrl) {
    return "".concat(getMondayFullUrlForSlug(getLastUsedAccountSlug())).concat(relativeUrl);
};
var validateAllAccountsCreatedAfterDate = function(date) {
    try {
        var slugs = getMondaySlugsDetails();
        var newSlugs = slugs.filter(function(slug) {
            return slug.ac && new Date(slug.ac) >= date;
        });
        return newSlugs.length === slugs.length;
    } catch (err) {
        Sentry.captureException(err);
        return false;
    }
};
var isExistingUserInWelcomeBackTest = function(abTests) {
    var persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_3__.shouldGetWelcomeBackPageTest)(abTests, persistantCookies) && persistantCookies[constants_cookies__WEBPACK_IMPORTED_MODULE_1__.WELCOME_BACK_SHOULD_UPDATE_CTA_COOKIE_NAME] === true;
};
var isExistingUserInHeader = function() {
    var persistantCookies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    try {
        var hasAccount = persistantCookies[constants_cookies__WEBPACK_IMPORTED_MODULE_1__.PLATFORM_PRICING_VERSION_COOKIE]; // All accounts have a pricing version set
        if (!hasAccount) return false;
        if ((0,services_dom_utils_service__WEBPACK_IMPORTED_MODULE_4__.isRunningInClient)()) {
            var lastSlug = getLastUsedAccountSlug();
            var slugsDetailsFromCookie = getMondaySlugsDetails();
            if (!lastSlug || !slugsDetailsFromCookie) return false; // something problematic with the cookies revert to regular header
        }
        return true;
    } catch (err) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureException */ .Tb(err);
        return false;
    }
};
var isExistingNonPayingAccount = function() {
    var persistantCookies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var hasAccount = persistantCookies[constants_cookies__WEBPACK_IMPORTED_MODULE_1__.PLATFORM_PRICING_VERSION_COOKIE]; // All accounts have a pricing version set
    var isPayingAccount = persistantCookies[constants_cookies__WEBPACK_IMPORTED_MODULE_1__.IS_PAYING_ACCOUNT_COOKIE_NAME];
    return hasAccount && !isPayingAccount;
};
var fireAbTestVariantInAccountTestIfNeeded = function() {
    var persistantCookies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cookieName = arguments.length > 1 ? arguments[1] : void 0, testName = arguments.length > 2 ? arguments[2] : void 0, testVariant = arguments.length > 3 ? arguments[3] : void 0;
    try {
        var variant = persistantCookies[cookieName];
        if (variant === testVariant && isRunningInClient()) {
            var _slugsDetailsFromCookie_, _slugsDetailsFromCookie_1;
            var slugsDetailsFromCookie = getMondaySlugsDetails();
            var pulseUserId = slugsDetailsFromCookie === null || slugsDetailsFromCookie === void 0 ? void 0 : (_slugsDetailsFromCookie_ = slugsDetailsFromCookie[0]) === null || _slugsDetailsFromCookie_ === void 0 ? void 0 : _slugsDetailsFromCookie_.ui;
            var pulseAccountId = slugsDetailsFromCookie === null || slugsDetailsFromCookie === void 0 ? void 0 : (_slugsDetailsFromCookie_1 = slugsDetailsFromCookie[0]) === null || _slugsDetailsFromCookie_1 === void 0 ? void 0 : _slugsDetailsFromCookie_1.ai;
            if (pulseUserId && pulseAccountId) {
                trackEvent(testName, {
                    ab_test: variant,
                    pulse_user_id: pulseUserId,
                    pulse_account_id: pulseAccountId
                });
            }
        }
    } catch (err) {
        Sentry.captureException(err);
    }
};
var setWelcomeBackCookie = function() {
    if (!(0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(constants_cookies__WEBPACK_IMPORTED_MODULE_1__.LAST_ACCOUNT_SLUG)) {
        // LAST_ACCOUNT_SLUG isn't in cloudfront cache - but this code runs on client side
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_9__/* .captureMessage */ .uT("Attempt to set Welcome back cookie on account without dapulseLastLoginAccount cookie");
        return;
    }
    (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(constants_cookies__WEBPACK_IMPORTED_MODULE_1__.WELCOME_BACK_SHOULD_UPDATE_CTA_COOKIE_NAME, "true", {
        expires: WELCOME_BACK_COOKIE_EXPIRATION_DAYS
    });
};
var getPlatformTemplateCenterPageSuffix = function(clusterId, subClusterId) {
    var _obj;
    var CLUSTER_TEMPLATE_CENTER_LINKS = (_obj = {}, _define_property(_obj, HR, "general__hr"), _define_property(_obj, OPERATIONS, "general__office_operations"), _define_property(_obj, IT, "general__office_operations"), _define_property(_obj, EDUCATION, "general__education"), _define_property(_obj, CONSTRUCTION, "general__construction"), _define_property(_obj, NON_PROFIT, "general__nonprofits"), _obj);
    var SUBCLUSTER_TEMPLATE_CENTER_LINKS = _define_property({}, WORK_DOCS_SUB_CLUSTER, "general__docs");
    var templateCenterSuffix = CLUSTER_TEMPLATE_CENTER_LINKS[clusterId] || SUBCLUSTER_TEMPLATE_CENTER_LINKS[subClusterId];
    if (templateCenterSuffix) return "template_center/category/".concat(templateCenterSuffix);
    return null;
};
var getWelcomeBackCTAProps = function(param) {
    var productId = param.productId, clusterId = param.clusterId, subClusterId = param.subClusterId, pricingDetails = param.pricingDetails, existingAccount = param.existingAccount;
    var ref = existingAccount || {}, existingAccountCtaText = ref.existingAccountCtaText, platformUrlOverrideForExistingAccount = ref.platformUrlOverrideForExistingAccount;
    var ctaTextKey = existingAccountCtaText || "existingAccount.mainCta";
    var platformRedirectUrl = getMondayUrl(platformUrlOverrideForExistingAccount);
    // COMMENTING OUT MULTIPLE CTA OPTIONS FOR WELCOME BACK - WILL RETURN IN FOLLOW UP TEST
    // Since work management is installed by default no need to "try it out"
    // if (productId && productId !== WORK_MANAGEMENT_PRODUCT_ID) {
    //   ctaTextKey = "existingAccount.installProduct";
    //   const platformProductId = getPlatformProductID(productId);
    //   platformRedirectUrl = `${platformRedirectUrl}/product_store/${platformProductId}`;
    // } else if (pricingDetails) {
    //   if (pricingDetails?.tier === TIERS.FREE) {
    //     return { hideButton: true };
    //   }
    //   // pricing but not for products
    //   ctaTextKey = "existingAccount.pricingCta";
    //   platformRedirectUrl = `${platformRedirectUrl}/open_payment_form`;
    //   platformRedirectUrl = addParamToURL(platformRedirectUrl, PAYMENT_TIER_PARAM, pricingDetails?.tier);
    //   platformRedirectUrl = addParamToURL(
    //     platformRedirectUrl,
    //     PAYMENT_PERIOD_PARAM,
    //     PLATFORM_PERIODS[pricingDetails?.billingPeriod]
    //   );
    //   platformRedirectUrl = addParamToURL(platformRedirectUrl, PAYMENT_USERS_COUNT_PARAM, pricingDetails?.userCount);
    //   platformRedirectUrl = addParamToURL(platformRedirectUrl, PAYMENT_SOURCE_PARAM, "website");
    // } else {
    //   const templateCenterLink = getPlatformTemplateCenterPageSuffix(clusterId, subClusterId);
    //   if (templateCenterLink) {
    //     ctaTextKey = "existingAccount.viewTemplates";
    //     platformRedirectUrl = `${platformRedirectUrl}/${templateCenterLink}`;
    //   }
    // }
    return {
        ctaTextKey: ctaTextKey,
        platformRedirectUrl: platformRedirectUrl
    };
};
var parseSingleAccountSlugDetails = function(slugsDetailsFromCookie) {
    if (!slugsDetailsFromCookie) return {};
    // Transforms cookie structure to the new short 2 letter key strcuture (old data is still with the long key names)
    return _object_spread_props(_object_spread({}, slugsDetailsFromCookie), {
        un: slugsDetailsFromCookie.un || slugsDetailsFromCookie.user_name,
        ue: slugsDetailsFromCookie.ue || slugsDetailsFromCookie.user_email,
        ui: slugsDetailsFromCookie.ui || slugsDetailsFromCookie.user_id,
        us: slugsDetailsFromCookie.us || slugsDetailsFromCookie.user_serial_number,
        up: slugsDetailsFromCookie.up || slugsDetailsFromCookie.user_image || DEFAULT_PLATFORM_USER_IMAGE_SOURCE,
        an: slugsDetailsFromCookie.an || slugsDetailsFromCookie.account_name,
        ac: slugsDetailsFromCookie.ac || slugsDetailsFromCookie.account_created,
        ai: slugsDetailsFromCookie.ai || slugsDetailsFromCookie.account_id,
        sl: slugsDetailsFromCookie.sl || slugsDetailsFromCookie.slug,
        lu: slugsDetailsFromCookie.lu || slugsDetailsFromCookie.last_used
    });
};
var getSignupLink = function(pageProductId) {
    if (pageProductId && shouldGetProductSignup(pageProductId)) {
        return getProductSignupURL(pageProductId);
    }
    return NEW_SOFT_SIGNUP_LINK;
};


/***/ })

}]);